// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-left: 20%;
    padding-right: 20%;
    padding-top: 5%;
}

.otp_header {
    text-align: center;
}

.otp_header h1 {
    font-size: 32px;
    font-weight: 700;
}

.otp_header p {
    font-size: 16px;
    font-weight: 500;
    color: var(--couleur-principale);
}

.otp_form {
    display: flex;
    justify-content: center;
    flex-direction: column;
}


.otp_form button {
    color: var(--white-principale);
    background-color: var(--couleur-principale);
    border: solid 1px var(--couleur-principale);
    border-radius: 100px;
    width: 100%;
    padding: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.otp_form input {
    background-color: var(--gris-secondaire-2);
    display: flex;
    align-items: center;
    padding: 20px;
    border: none;
    border-radius: 100px;
    margin-bottom: 20px;
}
.otp_form  input:focus,
.otp_form  input:active {
    border: none;
    outline: none;
    box-shadow: none;
}
.otp_form span {
    color: var(--white-principale);
}


.otp_form button:hover {
    background-color: var(--couleur-secondaire);
    border: solid 1px var(--couleur-secondaire);
    cursor: pointer;
}

.spinner-border{
    width : 3rem;
    height:3rem;
    border-width:0.3rem;
    border-top-color:var(--couleur-principale);
    border-right-color:var(--couleur-principale);
    border-bottom-color:var(--couleur-principale);
    border-left-color:transparent;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/authentification/otp.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;;AAGA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,2CAA2C;IAC3C,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;;;AAGA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,0CAA0C;IAC1C,4CAA4C;IAC5C,6CAA6C;IAC7C,6BAA6B;AACjC","sourcesContent":[".otp_container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding-left: 20%;\n    padding-right: 20%;\n    padding-top: 5%;\n}\n\n.otp_header {\n    text-align: center;\n}\n\n.otp_header h1 {\n    font-size: 32px;\n    font-weight: 700;\n}\n\n.otp_header p {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--couleur-principale);\n}\n\n.otp_form {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n\n.otp_form button {\n    color: var(--white-principale);\n    background-color: var(--couleur-principale);\n    border: solid 1px var(--couleur-principale);\n    border-radius: 100px;\n    width: 100%;\n    padding: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.otp_form input {\n    background-color: var(--gris-secondaire-2);\n    display: flex;\n    align-items: center;\n    padding: 20px;\n    border: none;\n    border-radius: 100px;\n    margin-bottom: 20px;\n}\n.otp_form  input:focus,\n.otp_form  input:active {\n    border: none;\n    outline: none;\n    box-shadow: none;\n}\n.otp_form span {\n    color: var(--white-principale);\n}\n\n\n.otp_form button:hover {\n    background-color: var(--couleur-secondaire);\n    border: solid 1px var(--couleur-secondaire);\n    cursor: pointer;\n}\n\n.spinner-border{\n    width : 3rem;\n    height:3rem;\n    border-width:0.3rem;\n    border-top-color:var(--couleur-principale);\n    border-right-color:var(--couleur-principale);\n    border-bottom-color:var(--couleur-principale);\n    border-left-color:transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
